module.exports = __webpack_public_path__ + "static/img/ede5545f32f874731e7ff9f62748c9d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bk_white.png
// module id = +DNQ
// module chunks = 1